import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider, theme } from 'antd';
import { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppLocale from './lngProvider';
import RoutesApp from './routes';
import { RootState, useAppDispatch } from './store';
import { updateWindowWidth } from './store/settingSlice';

const App = () => {
  const { locale, isDarkMode } = useSelector((state: RootState) => state.setting);

  const dispatch = useAppDispatch();
  const currentAppLocale = (AppLocale as any)[locale.locale];

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  // useEffect(() => {
  //   const handleResizeWindow = () => {
  //     dispatch(updateWindowWidth(window.innerWidth));
  //   };

  //   window.addEventListener('resize', handleResizeWindow);

  //   return () => {
  //     window.removeEventListener('resize', handleResizeWindow);
  //   };
  // }, [dispatch]);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        }}
        locale={currentAppLocale.antd}
        autoInsertSpaceInButton={false}
      >
        <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
          <RoutesApp />
        </IntlProvider>
      </ConfigProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        rtl={false}
        draggable={false}
        theme="colored"
      />
    </QueryClientProvider>
  );
};

export default App;
